import {Component, DestroyRef, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {
  ActivateOutlet,
  Outlet,
} from '../../app-shared/models/supplier-outlet.model';
import { SupplierOutletService } from '../../app-shared/services/supplier-outlet.service';
import { SettingsService } from '../../app-shared/services/settings.service';
import { Router } from '@angular/router';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-select-outlet-activation-result',
    templateUrl: './select-outlet-activation-result.component.html',
    styleUrls: ['./select-outlet-activation-result.component.scss'],
    standalone: false
})
export class SelectOutletActivationResultComponent {
  outlet: Outlet;
  resultOutlet: ActivateOutlet;
  mobile: boolean;
  loading: boolean;
  @Output() goNext = new EventEmitter();
  @Output() selectOutlet = new EventEmitter();
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private supplierOutletService: SupplierOutletService,
    private settings: SettingsService,
    private router: Router
  ) {
    this.outlet =
      this.supplierOutletService.getSelectOutletForActivateCatalog();
    this.resultOutlet =
      this.supplierOutletService.getResultOutletForActivateCatalog();
    this.mobile = this.settings.isMobileSize();
  }

  activateOutlet() {
    this.loading = true;
    this.supplierOutletService
      .activateOutletByActivationCode({
        outletId: this.outlet.outletId,
        activationCode: this.resultOutlet.activationCode,
      })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.goNext.emit();
          this.router.navigate(['/suppliers']);
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  selectOutletClick() {
    this.supplierOutletService.removeSelectOutletForActivateCatalog();
    this.selectOutlet.emit();
    if (this.mobile) {
      this.router.navigate(['/addcategory/select-outlet']);
    }
  }
}
